<div
  class="bar"
  [class.positive]="(isPositive() && isAligned()) || (!isPositive() && !isAligned())"
  [style.width.%]="barWidth()"
  [style.left.%]="barPosition()"
></div>
<div
  class="zero"
  [style.left.%]="zeroPosition()"
></div>
